document.addEventListener('alpine:init', () => {
  Alpine.data(
    'linkProductPropertiesField', () => ({
      query: '',
      isProductSelected: false,
      isOpen: false,
      isError: false,
      results: [],

      async search() {

        this.isProductSelected = false;
        this.isError = false;

        if (!this.query || this.query.length < 2) {
          this.results = [];
          this.isOpen = false;
          return;
        }

        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(this.query)}&resources[type]=product&&resources[options][unavailable_products]=hide&resources[options][fields]=title&resources[limit]=3`);
          const data = await res.json();
          this.results = data.resources.results.products.filter(
            product => product.type === 'Papier peint'
          );
          console.log("result", this.results);
          this.isOpen = true;
        } catch (error) {
          this.results = [];
          this.isOpen = false;
        }
      },

      select(item) {
        this.query = item.title;
        this.isProductSelected = true;
        this.isOpen = false;
        this.results = [];
      },

      handleBlur() {
        setTimeout(() => {
          this.isOpen = false;
          this.results = [];
          if(this.isProductSelected === false){
            this.query = '';
          }
        }, 200)
      },

      bindSubmitButton() {
        const form = this.$el.closest('form');
        const submitButton = form.querySelector('[type="submit"]');

        if (submitButton) {
          submitButton.addEventListener('click', (event) => {
            if (this.isProductSelected === false) {
              this.isError = true;
              event.preventDefault();
            }
          });
        }
      }

    })
  );
});